import React, { Component } from "react";

class BordComponent extends Component {
  render() {
    return (
      <div
        style={{
          width: "200px",
          height: "100px",
          backgroundColor: "#026AA7",
          backgroundImage: `url("${this.props.backroundIMG}")`,
        }}
      >
        <span
          style={{
            color: "white",
            fontWeight: "bold",
            padding: "5px",
            fontSize: "15px",
          }}
        >
          {this.props.data.name}
        </span>
      </div>
    );
  }
}

export default BordComponent;
